/**
 * Owns: shared custom event name constants for the store-location feature stack.
 * Exposes: STORE_SELECTED_EVENT, STORE_LOCATOR_SOURCE, FULFILLMENT_*, DELIVERY_ZIP_*,
 *   STORE_ATC_PRESENTATION_CHANGED_EVENT, STORE_AVAILABILITY_LOADING_EVENT,
 *   STORE_INVENTORY_SETTLED_EVENT.
 * Consumes: (none)
 */

/** @type {string} Dispatched on document when cart store attributes change after locator selection. */
export const STORE_SELECTED_EVENT = 'store-locator:store-selected';

/** @type {string} CartUpdateEvent detail.source value for locator-driven cart updates. */
export const STORE_LOCATOR_SOURCE = 'store-locator';

/** @type {'delivery'} */
export const FULFILLMENT_DELIVERY = 'delivery';

/** @type {'pickup'} */
export const FULFILLMENT_PICKUP = 'pickup';

/** @type {string} Dispatched on document when PDP pickup/delivery selection changes. */
export const FULFILLMENT_CHANGED_EVENT = 'fulfillment:changed';

/** @type {string} Dispatched on document after delivery ZIP modal validates a ZIP. */
export const DELIVERY_ZIP_CHECKED_EVENT = 'delivery-zip:checked';

/** @type {string} Dispatched on store-product-availability when main/sticky ATC presentation changes. */
export const STORE_ATC_PRESENTATION_CHANGED_EVENT = 'store-atc:presentation-changed';

/** @type {string} Dispatched on store-product-availability while inventory fetch is in flight. */
export const STORE_AVAILABILITY_LOADING_EVENT = 'store-availability:loading';

/** @type {string} Dispatched when store-product-availability finishes a non-stale inventory render. */
export const STORE_INVENTORY_SETTLED_EVENT = 'store-inventory:settled';
